import { render, staticRenderFns } from "./S4Login.vue?vue&type=template&id=549f222c"
import script from "./S4Login.vue?vue&type=script&lang=js"
export * from "./S4Login.vue?vue&type=script&lang=js"
import style0 from "./S4Login.vue?vue&type=style&index=0&id=549f222c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports